import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { pageActions } from '../ActionTypes';


export const fetchPage = () => async (dispatch) => {
  try {
    dispatch({
      type: pageActions.PAGE_FETCH_START
    });

    const resData = await Service.GET({
      name: 'page',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: pageActions.PAGE_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: pageActions.PAGE_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const savePage = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData
    };
    dispatch({
      type: pageActions.PAGE_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'page',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: pageActions.PAGE_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/page'; }, 1000);
  } catch (error) {
    dispatch({
      type: pageActions.PAGE_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editPage = (pageId) => async (dispatch, getState) => {
  try {
    const { pageList } = getState().page;
    const data = pageList.find((item) => item.Id === pageId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: pageActions.PAGE_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: pageActions.PAGE_RESET_FORM });

export const deletePage = (Id) => async (dispatch) => Service.DELETE({
  name: 'page',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchPage());
    return true;
  }
  throw new Error(res.message);
});
